module.exports = __webpack_public_path__ + "img/bg-pattern.f0458cff.png";